import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpErrorInterceptor } from './core/interceptors/http-error/http-error.interceptor';
import { MainLayoutComponent } from './layouts/containers/main-layout/main-layout.component';
import { ApiHeaderInterceptor } from './core/interceptors/api-header/api-header.interceptor';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { AuthLayoutComponent } from './layouts/containers/auth-layout/auth-layout.component';
import { LocalStorage } from './core/services/local-storage/local-storage.service';
import { CourseSidebarComponent } from './layouts/course-sidebar/course-sidebar.component';
import { SidebarLayoutComponent } from './layouts/containers/sidebar-layout/sidebar-layout.component';
import { provideAppConfig } from '@core/config/app-config.provider';
import { register } from 'swiper/element/bundle';
import { SharedModule } from './shared/shared.module';
import { GtmService } from '@core/services/common/gtm.service';
import { PushLiveSidebarComponent } from './layouts/push-live-sidebar/push-live-sidebar.component';
import { PushLiveSidebarLayoutComponent } from './layouts/containers/push-live-sidebar-layout/push-live-sidebar-layout.component';

export function initGTM(gtmService: GtmService): () => void {
  return () => gtmService.init();
}

register();

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    HeaderComponent,
    FooterComponent,
    AuthLayoutComponent,
    CourseSidebarComponent,
    SidebarLayoutComponent,
    PushLiveSidebarComponent,
    PushLiveSidebarLayoutComponent,
  ],
  imports: [BrowserModule, AppRoutingModule, HttpClientModule, FormsModule, SharedModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initGTM,
      deps: [GtmService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    provideAppConfig(),
    LocalStorage,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
